import { TFunction } from 'i18next';
import { Numbers } from '../../../lib/utils/number-formatting/Numbers';

export class ConvertUnitUtils {
  public static covertSquareMetersToSquareFeet(squareMeters: number): number {
    const result = Numbers.formatNumberDecimalRounded(squareMeters * 10.7639, 1);
    return result;
  }

  public static converMetersToMiles(meters: number): number {
    const result = Numbers.formatNumberDecimalRounded(meters * 0.000621371, 4);
    return result;
  }

  public static convertMetersToKilometers(meters: number): number {
    const result = Numbers.formatNumberDecimalRounded(meters / 1000, 1);
    return result;
  }

  public static convertMetersToFeetFactor(meters: number): number {
    const result = Numbers.formatNumberDecimalRounded(meters * 3.28084, 1);
    return result;
  }

  public static convertLitersToGallons(liters: number): number {
    const result = Numbers.formatNumberDecimalRounded(liters * 0.264172, 1);
    return result;
  }

  public static convertLiterToFluidOunces(liters: number): number {
    const result = Numbers.formatNumberDecimalRounded(liters * 33.814, 1);
    return result;
  }

  public static splitHoursToHoursAndMinutes(hours: number, t: TFunction): string {
    if (!hours || hours <= 0) return `0${t('common.hUnit')} 0${t('common.mUnit')}`;

    const totalMinutes = Math.round(hours * 60);
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;

    return `${h}${t('common.hUnit')} ${m}${t('common.mUnit')}`;
  }
}
